// Staff class
export class Staff {
    constructor(model) {
        // console.log("Model from staff: ", JSON.stringify(model, null, 4));
        this.id = model.id;
        this.first_name = model.first_name;
        this.surname = model.surname;
        this.middle_name = model.middle_name;
        this.mobile = model.mobile;
        this.designation = {
            id: model.designation.id,
            name: model.designation.name
        };
        this.department = {
            id: model.department.id,
            name: model.department.name
        };
        this.type = {
            id: model.type.id,
            name: model.type.name
        };
        this.admin = model.admin;
        this.site = {
            id: model.site.id,
            name: model.site.name,
            email: model.site.email,
            type: {
                id: model.site.type && model.site.type.id,
                name: model.site.type && model.site.type.name
            },
            parent: {
                id: model.site.parent && model.site.parent.id,
                name: model.site.parent && model.site.parent.name
            }
        };
        this.email = model.email;
        this.created_at = model.created_at;
        this.patients = model.patients || [];
        this.image = model.image;
        this.topStaff = model.topStaff;
        this.gender = model.gender;
        this.name = `${model.surname} ${model.first_name} ${model.middle_name !== null ? model.middle_name : ""}`;
    }
}
